/* React */
import React, { useEffect } from "react";

/* React Router */
import { Route, RouteProps } from "react-router-dom";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

/* Thunks */
import { fetchUserRoles } from "src/redux/thunks/auth/userRolesThunk";
import { UserRoles } from "src/shared/constants/auth/User";

/* Components */
import ForbiddenContainer from "src/components/auth/forbidden-container/ForbiddenContainer";

interface AdminRouteProps {
  component: React.ComponentType<RouteProps>;
  path: string;
  exact?: boolean;
}

const AdminRoute: React.FC<AdminRouteProps> = ({
  component: Component,
  exact,
  ...rest
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const authState = useSelector(
    (state: RootState) => state.auth
  );

  const { roles } = authState;

  useEffect(() => {
    dispatch(fetchUserRoles());
  }, [dispatch]);

  const isAdmin = roles.includes(UserRoles.ADMIN);
  if (!isAdmin) return null;

  return (
    <Route
      {...rest}
      exact={exact}
      render={(props) =>
        isAdmin ? (
          <Component {...props} />
        ) : (
          <ForbiddenContainer />
        )
      }
    />
  );
};

export default AdminRoute;
